// CYCLE PAGE COMPONENT, DISPLAYS HOMEITEM COMPONENTS

import React, { useContext, useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import { LanguageContext } from "./../language-context";
import { Link, useNavigationType } from "react-router-dom";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { HomeItem } from "./HomeItem";
import { PageTitle } from "./helper/PageTitle";
import { Scroll } from "./helper/Scroll";
import { ScrollTracker } from "./helper/ScrollTracker";
import { pl } from "./../data/pl";

const Paintings = styled.article`
  ${variables.Flex};
  flex-wrap: wrap;
  width: 100vw;
  height: auto;
  min-height: 200vh;
  padding: 7rem 0;
  background-color: ${variables.BACKGROUND_GRAY};
`;

const PaintingWrapper = styled.div`
  margin: 0 2vw;
`;

export const Cycle = () => {
  const usedLanguage = useContext(LanguageContext);
  const { artworks, poetry } = pl; //pl because this data is the same no matter the language

  const cycleTitle = decodeURIComponent(
    window.location.href
      .substring(window.location.href.lastIndexOf("/") + 1)
      .replace("%20", " ")
  );

  let cycle = cycleTitle;

  if (cycleTitle === "SCULPTURE" || cycleTitle === "SKULPTUR") {
    cycle = "RZEŹBA";
  } else if (cycleTitle === "POETRY" || cycleTitle === "POESIE") {
    cycle = "POEZJA";
  } else if (cycleTitle === "OTHER" || cycleTitle === "SONSTIGES") {
    cycle = "INNE";
  }

  function reorderForGrid(data) {
    if (!data || typeof data !== "object") {
      console.error("Expected an object");
      return {};
    }

    const entries = Object.entries(data);

    for (let i = 3; i < entries.length; i += 4) {
      const [key, item] = entries[i];
      const width = parseInt(item.artworkWidth) || 1;

      if (width === 2) {
        // Szukamy najbliższego późniejszego elementu o szerokości 1
        for (let j = i + 1; j < entries.length; j++) {
          const nextWidth = parseInt(entries[j][1].artworkWidth) || 1;
          if (nextWidth === 1) {
            // Zamieniamy miejscami
            const temp = entries[i];
            entries[i] = entries[j];
            entries[j] = temp;
            break;
          }
        }
      }
    }

    return Object.fromEntries(entries);
  }

  const reordered = reorderForGrid(artworks);
  console.log(reordered);
  Scroll();
  ScrollTracker();

  return (
    <>
      <MetaTags>
        <title>Structuralist | Structural Collage | Interior</title>
        <meta
          name="description"
          content="Michał Król to młody artysta - outsider i samouk, który tworzy kolaż strukturalny. Wszystkie dotychczasowe prace dostępne są na niniejszej, oficjalnej stronie."
        />
        <meta
          name="keywords"
          content={`"Structuralist", "Michał Król", "Structural Collage", "Interior"`}
        />
      </MetaTags>
      <Paintings>
        <PageTitle
          text={cycleTitle}
          backgroundColor={variables.BACKGROUND_GRAY} //Styled Components props
        />
        {/* eslint-disable-next-line*/}
        {cycle === "POEZJA"
          ? Object.keys(poetry).map((poetryBook) => (
              <PaintingWrapper key={poetryBook}>
                <Link
                  to={`/poetry/${poetryBook}`}
                  style={{ textDecoration: "none" }}
                >
                  <HomeItem artworkId={poetryBook} />
                </Link>
              </PaintingWrapper>
            ))
          : Object.keys(reordered)
              .filter((artwork) => artworks[artwork].artworkCycle === cycle)
              .map((artwork) => (
                <PaintingWrapper key={artwork}>
                  <Link
                    to={`/artworks/${artwork}`}
                    style={{ textDecoration: "none" }}
                  >
                    <HomeItem artworkId={artwork} />
                  </Link>
                </PaintingWrapper>
              ))}
      </Paintings>
    </>
  );
};
